import { render, staticRenderFns } from "./QuizButton.vue?vue&type=template&id=cb68ed36&scoped=true&"
import script from "./QuizButton.vue?vue&type=script&lang=js&"
export * from "./QuizButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb68ed36",
  null
  
)

export default component.exports